module.exports = __webpack_public_path__ + "img/icon_success.073b014b.png";